// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__hLHyT"};